import { Navigate, Outlet, useLocation } from 'react-router';
import { selectOptionalUser } from 'features/auth/store/authSelectors';
import { useAppSelector } from 'features/store/hooks';

export const DemoProtectedRoutes = () => {
  const user = useAppSelector(selectOptionalUser);
  const location = useLocation();

  if (user) {
    return <Outlet />;
  } else {
    const params = new URLSearchParams();
    params.set('from', location.pathname);
    return <Navigate to={'/login?' + params.toString()} />;
  }
};
